import React, { useState, useCallback } from 'react';
import { modificatorKeys } from './modificator-keys';
import { StylesContext } from './styles.context';
import { IGradientSchema } from './types/gradient-schema.interface';
import { IModifications } from './types/modifications.type';
import { IStylesSettings } from './types/styles-settings.interface';
import { IStylesType } from './types/styles.type';

export default function StylesContextWrapper(props: React.PropsWithChildren<any>) {
  const [styles, setStyles] = useState<IStylesType>({});

  const generateStyles = useCallback((settings: IModifications) => {
    setStyles(getSettings(settings));
  }, []);

  return (
    <StylesContext.Provider value={{ styles, generateStyles }}>
      {props.children}
    </StylesContext.Provider>
  );
}

function getSettings(modifications: IModifications) {
  let styles: IStylesType = {
    common: modifications.common
  };

  for (let key of modificatorKeys) {
    if (modifications[key]) styles[key] = getStyles(modifications[key]);
    else styles[key] = {} as CSSStyleDeclaration;
  }

  if (modifications.common) {
    setBackground(modifications, styles, "primaryButtons", "primary");
    setBackground(modifications, styles, "flyingButton", "primary");
    setBackground(modifications, styles, "agreementCheckbox", "primary");
    setBackground(modifications, styles, "checkedPlainAnswer", "secondary");
    setBackground(modifications, styles, "progressTrack", "secondary");
  }
  
  return styles;
}

function setBackground(modifications: IModifications, styles: IStylesType, modificatorKey: keyof Omit<IModifications, "common">, type: "primary" | "secondary") {
  const gradientSchema: IGradientSchema[] = modifications.common[type + "GradientSchema"];
  const color = modifications.common[type + "Color"];

  if (!(styles[modificatorKey].background || styles[modificatorKey].backgroundColor)) {
    styles[modificatorKey] = {
      ...styles[modificatorKey],
      ...getStyles({ 
        gradientSchema: gradientSchema,
        backgoundColor: color,
      })
    }
  }
}

function getStyles(settings: IStylesSettings) {
  let styles: CSSStyleDeclaration = {} as CSSStyleDeclaration;
  let key: keyof typeof settings;

  if (settings) {
    for (key in settings) {
      if (key != "gradientSchema") styles[key] = settings[key];

      if (settings.backgoundColor) styles.background = settings.backgoundColor;
      
      if (settings.gradientSchema) {
        const colors = settings.gradientSchema.map(item => `${item.color} ${item.rate}`);
        styles.background = `linear-gradient(${settings.gradientDirection || "to bottom"}, ${colors.join(", ")})`;
      }

      if (settings.borderColor || settings.borderWidth) {
        styles.borderStyle = "solid";
        styles.borderWidth = settings.borderWidth || "1px";
      }

    }
  }

  return styles;
}